exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2KTRSIQofj3fZ6k9_C1dws {\n  width: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"imgResponsive": "_2KTRSIQofj3fZ6k9_C1dws"
};